module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAs0lEQVRYR+2XwQnCQBBF33TgWXKwFO3Ak5ButAt7CKlBO/GQEoLnFYPoggGHWXAP+XvdnT+fN/CHNSofq9wfGSgkkFbAHujBxsg4Sw2kV9Md2FUGREAERKAyAU/777CaScK0AW4eucCbE9gxr5sz0ABDQNxTcgDrfhh4XqetRw24fHaBp8I1Ao/Q22Rm4O/LaKIkAyIgAosmMIVRC6yBM9jdG2GOKI5IxWoK/wWxpiKQE3gAYyNIIWJQ9AIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/component/adduser/plus_icon.png
// module id = Og2E
// module chunks = 1